import { ref } from "@vue/reactivity";
import { getJsUrl } from '@/utils/function';
import { createI18n } from 'vue-i18n';
import CN from './CN';
import RU from './RU';

var route:any;

if(location.href.indexOf('?') !== -1){
    route = getJsUrl(location.href);
}

if(route && route.language){
    sessionStorage.setItem('locale-language',route.language);
}else{
    const country = sessionStorage.getItem('locale-language');
    country ? sessionStorage.setItem('locale-language',country) : sessionStorage.setItem('locale-language','en');
}



export const LOCALE_OPTIONS = [
    { label: '中文', value: 'cn' },
    { label: '俄罗斯', value: 'ru' },
];

const defaultLocale = ref(sessionStorage.getItem('locale-language') ? sessionStorage.getItem('locale-language') : route.language ? route.language : 'cn');

const i18n = createI18n({
    locale: defaultLocale.value,
    fallbackLocale: 'cn',
    allowComposition: true,
    messages: {
        cn:CN,
        ru:RU,
    }
});

export {
    defaultLocale,
    i18n
};